import React from 'react';
import LocationTemplate from './LocationTemplate';

const ElizabethtownPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Elizabethtown"
      stateName="North Carolina"
      countyName="Bladen"
      zipCodes={["28337"]}
      latitude={34.6290}
      longitude={-78.6089}
      population={3583}
      historicalFact="County seat of Bladen County, incorporated in 1895 and named after Elizabeth Tory."
      nearbyTowns={[
        "Bladenboro, NC",
        "White Lake, NC",
        "Dublin, NC",
        "Tar Heel, NC",
        "Clarkton, NC",
        "Lumberton, NC",
        "Whiteville, NC",
        "Fayetteville, NC"
      ]}
    />
  );
};

export default ElizabethtownPage;